import React, { useRef, useState, useEffect } from "react";
import TiptapEditor from '../utils/TipTapEditor.js';
import FlyerEditor from '../utils/FlyerEditor';
import { log } from "../utils/debug";

const InviteForm = ({ data, setData, onChange, onSubmit, recipients, setRecipients }) => {
  const editorRef = useRef();
  const [showFlyerEditor, setShowFlyerEditor] = useState(false);
  const flyerFileRef = useRef();

  const updateRecipient = (index, field, value) => {
    const updated = [...recipients];
    updated[index][field] = value;
    setRecipients(updated);
  };

  const removeRecipient = (index) => {
    if (recipients.length === 1) return;
    const updated = recipients.filter((_, i) => i !== index);
    setRecipients(updated);
  };

  const addRecipient = () => {
    setRecipients([...recipients, { name: '', email: '' }]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (showFlyerEditor) {
      alert("Please close the flyer editor before submitting.");
      return;
    }

    const messageHTML = editorRef.current?.getHTML();
    if (!messageHTML || messageHTML === '<p></p>') {
      alert("Please type a message before submitting.");
      return;
    }

    const start = new Date(data.event_start);
    const end = new Date(data.event_end);
    if (start >= end) {
      alert("End date/time must be after start date/time.");
      return;
    }

    const flyerFile = data.flyer || flyerFileRef.current?.files?.[0] || null;
    onSubmit(messageHTML, flyerFile);
  };

  const handleFlyerExport = (dataUrl) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);

    const file = new File([u8arr], "flyer.png", { type: mime });

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);

    if (flyerFileRef.current) {
      flyerFileRef.current.files = dataTransfer.files;
    }

    setShowFlyerEditor(false);
    setData({ ...data, flyer: file });

    console.log("🖼️ Flyer set:", file);
  };

  useEffect(() => {
    document.body.style.overflow = showFlyerEditor ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showFlyerEditor]);

  return (
    <form onSubmit={handleSubmit} className="container invite">
      <div>
        <h2 className="app-header">Event Invitation</h2>
        <input name="event_title" placeholder="Event Title" onChange={onChange} value={data.event_title} required /><br />
        <input name="location" placeholder="Event Location" onChange={onChange} value={data.location} required /><br />
        <TiptapEditor content={data.message} ref={editorRef} name="message" />
        <br />
        <label htmlFor="event_start">Start:</label>
        <input type="datetime-local" id="event_start" min={new Date().toISOString().slice(0, 16)} name="event_start" onChange={onChange} required />
        <label htmlFor="event_end">End:</label>
        <input type="datetime-local" id="event_end" name="event_end" min={data.event_start} onChange={onChange} required /><br />

        <div className="flyer-options" style={{ margin: '10px 0' }}>
        <label>Flyer:</label>
        {!data.flyer ? (
          <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
            <input
              type="file"
              accept="image/*"
              ref={flyerFileRef}
              style={{flex: '1', margin: '0'}}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setData({ ...data, flyer: file });
                  log("Uploaded flyer:", file);
                }
              }}
            />
            <button type="button" style={{flex: '1'}} onClick={() => setShowFlyerEditor(true)}>Create Flyer</button>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '5px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '5px' }}>
            <img
              src={URL.createObjectURL(data.flyer)}
              alt="Flyer Preview"
              style={{ width: '100px', height: 'auto', borderRadius: '4px', boxShadow: '0 0 5px rgba(0,0,0,0.2)' }}
            />
            <button
              type="button"
              onClick={() => {
                if (flyerFileRef.current) {
                  flyerFileRef.current.value = "";
                }
                setData({ ...data, flyer: null });
              }}
            >
              Remove Flyer
            </button>
          </div>
          </div>
        )}
      </div>


        {showFlyerEditor && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="modal-close" onClick={() => setShowFlyerEditor(false)}>&times;</button>
              <FlyerEditor onExport={handleFlyerExport} onClose={() => setShowFlyerEditor(false)} />
            </div>
          </div>
        )}

        {recipients.map((r, idx) => (
          <div key={idx} className="recipientDiv">
            <input
              placeholder="Name"
              name={`Name_${idx}`}
              value={r.name}
              onChange={(e) => updateRecipient(idx, "name", e.target.value)}
              required
            />
            <input
              placeholder="Email"
              name={`Email_${idx}`}
              value={r.email}
              onChange={(e) => updateRecipient(idx, "email", e.target.value)}
              required
            />
            {recipients.length > 1 ? (
              idx > 0 ? (
                <button className="simple-btn" type="button" onClick={() => removeRecipient(idx)}><i className="fa-solid fa-xl fa-xmark text-decline" /></button>
              ) : (
                <button className="simple-btn placeholder" type="button"><i className="fa-solid fa-xl fa-xmark text-decline" /></button>
              )
            ) : null}
          </div>
        ))}

        <div className="footer-btns">
          <button type="button" onClick={addRecipient} className="simple-link"><i className="fa-solid fa-plus"></i>Add Another</button>
          <button type="submit" disabled={showFlyerEditor}>Send Invite</button>
        </div>
      </div>
    </form>
  );
};

export default InviteForm;
